import { useAppSelector } from '../../state/hooks'
import { selectIsSavedService } from '../../state/slices/currentSale/currentSaleSlice'
import { useSaleHasServiceOrder } from './useSaleHasServiceOrder'

/**
 * Hook to check if the current sale is a continued service sale
 * (i.e., a service sale that was saved and is being continued)
 *
 * @returns True if the sale is both a service order AND was previously saved (continued), false otherwise
 */
export const useSaleIsContinuedServiceSale = (): boolean => {
  const isSavedService = useAppSelector(selectIsSavedService)
  const saleHasServiceOrder = useSaleHasServiceOrder()

  return Boolean(isSavedService) && saleHasServiceOrder
}
